import styled from "styled-components";
import RedirectComponent, { RedirectText } from "../RedirectComponent";
import { ErrorIcon } from "@cleverbase-trust-drivers/shared/images/Error";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 400px;
  gap: 24px;
`;

const TitleBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const ErrorTitle = styled.h2`
  text-align: center;
  font-family: ${({ theme }) => theme.headingFontFamily};
  font-weight: 400;
  font-size: 3rem;
  line-height: 3.6rem;
  color: #23231f;
  margin: 0;
`;

const BodyBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const ErrorText = styled.p`
  text-align: center;
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-weight: 400;
  color: #23231f;
  margin: 0;
`;

const ProcessId = styled.p`
  color: #55544c;
  text-align: center;
  font-size: 12px;
  margin: 0;
`;

const RedirectTextWrap = styled.div`
  & p {
    font-size: 1.6rem;
    line-height: 2.2rem;
    font-weight: 400;
    color: #23231f;
    margin: 0;
  }
`;

export interface ErrorProps {
  redirectUri?: string | undefined;
  isDesktop: boolean;
  clientName?: string | undefined;
  t: ErrorText;
  processId?: string | undefined;
  errorVariant?: "authentication" | "identification";
}

export interface ErrorText {
  errorTitle: string;
  errorText: string;
  redirectText: RedirectText;
}

export default function Error({
  clientName,
  redirectUri,
  t,
  processId,
  errorVariant,
}: ErrorProps): JSX.Element {
  return (
    <Container data-testid="error">
      <TitleBlock>
        <ErrorTitle data-testid="error_title">{t.errorTitle}</ErrorTitle>
      </TitleBlock>
      <BodyBlock>
        <ErrorText data-testid="error_text">{t.errorText}</ErrorText>
        {!!redirectUri && (
          <RedirectTextWrap>
            <RedirectComponent
              seconds={10}
              redirectToUri={redirectUri}
              t={t.redirectText}
              clientName={clientName}
            />
          </RedirectTextWrap>
        )}
        <ErrorIcon {...(errorVariant ? { variant: errorVariant } : {})} />
        {!!processId && (
          <ProcessId data-testid="error_processId">{processId}</ProcessId>
        )}
      </BodyBlock>
    </Container>
  );
}
